<div class="page-container">
  @if (!isLoading) {
    <div class="page-navigation">
      <div class="buttons">
        <button
          type="button"
          class="inwi-icon-text-button-medium-secondary"
          (click)="onCancel()">
          <div class="button-content">
            <i class="fa-regular fa-xmark button-icon"></i>
            <div class="button-text">Abbrechen</div>
          </div>
        </button>
        <button
          type="button"
          class="inwi-icon-text-button-medium-primary"
          (click)="onSubmit()"
          [disabled]="form.invalid || isLoading">
          <div class="button-content">
            <i class="fa-regular fa-floppy-disk button-icon"></i>
            @if (isLoading) {
              <div class="button-text">Bitte warten...</div>
            } @else if (editMode) {
              <div class="button-text">Speichern</div>
            } @else {
              <div class="button-text">Mitgliederbereich erstellen</div>
            }
          </div>
        </button>
      </div>
    </div>

    <div
      class="font-bold-display-medium gap-8 flex-r align-center padding-16-0">
      @if (editMode) {
        <i class="fa-regular fa-pen title-icon"></i>
        <span class="font-bold-display-medium">
          Mitgliederbereich bearbeiten</span
        >
      } @else {
        <i class="fa-regular fa-plus title-icon"></i>
        <span class="font-bold-display-medium">
          Mitgliederbereich hinzufügen</span
        >
      }
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form">
      <div class="flex-c gap-8 align-self-stretch">
        <span class="font-medium-headline-medium"> Vorschau </span>
        <div class="member-area">
          @if (selectedImage) {
            <img
              class="image"
              [src]="selectedImage"
              alt="Bild des Mitgliederbereichs" />
          }
          <div class="details">
            <div class="title">
              Mitgliederbereich {{ form.controls.name.value }}
            </div>
            <div class="role">
              <span class="role-chip"> Eigentümer </span>
            </div>
            @if (form.controls.description.value) {
              <div class="subtitle">
                {{ form.controls.description.value }}
              </div>
            }
          </div>
        </div>
      </div>
      <div class="input-simple align-self-stretch radio-button-input">
        <div class="flex-r gap-16 justify-space-between align-center w-full">
          <div class="input-label">Öffentlicher Mitgliederbereich?</div>
          <div class="radio-buttons">
            <label
              for="isPublicTrue"
              class="inwi-radio font-regular-body-large">
              <input
                id="isPublicTrue"
                type="radio"
                [value]="true"
                formControlName="isPublic" />
              <span> Ja </span>
            </label>
            <label
              for="isPublicFalse"
              class="inwi-radio font-regular-body-large">
              <input
                id="isPublicFalse"
                type="radio"
                [value]="false"
                formControlName="isPublic" />
              <span> Nein </span>
            </label>
          </div>
        </div>
        <app-error-message
          [formField]="form.get('isPublic')"></app-error-message>
      </div>
      <div class="input-simple align-self-stretch">
        <div class="input-label-wrapper">
          <label for="description" class="input-label">
            Name
            {{ fieldRequired(form.get('name')) ? '*' : '' }}
          </label>
        </div>
        <input
          id="name"
          name="name"
          class="input-textarea"
          rows="4"
          placeholder="Name des Bereichs"
          formControlName="name" />
        <app-error-message [formField]="form.get('name')"></app-error-message>
      </div>

      @if (!form.controls.isPublic.value) {
        <div class="input-select align-self-stretch">
          <div class="input-label" for="ownerId">
            Eigentümer {{ fieldRequired(form.get('ownerId')) ? '*' : '' }}
          </div>
          <p-select
            formControlName="ownerId"
            [options]="userOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Eigentümer auswählen..."
            [filter]="true"
            filterBy="label">
          </p-select>
          <app-error-message
            [formField]="form.get('ownerId')"></app-error-message>
        </div>
      }
      <div class="input-simple align-self-stretch">
        <div class="input-label-wrapper">
          <label for="contactEmail" class="input-label">
            Kontakt-E-Mail (für "Kontakt"-Button, wird nicht angezeigt)
          </label>
        </div>
        <input
          id="contactEmail"
          name="contactEmail"
          type="email"
          class="input-field"
          placeholder="kontakt@example.com"
          formControlName="contactEmail" />
        <app-error-message
          [formField]="form.get('contactEmail')"></app-error-message>
      </div>
      <div class="input-simple align-self-stretch">
        <div class="input-label-wrapper">
          <label for="description" class="input-label">
            Beschreibung{{ fieldRequired(form.get('description')) ? '*' : '' }}
          </label>
          <div class="input-label-hint">
            {{ getTextAreaLength(form.controls['description']) }}
            /
            {{ getMaxLengthFromValidator(form.controls['description']) }}
          </div>
        </div>
        <textarea
          id="description"
          name="description"
          class="input-textarea"
          rows="4"
          placeholder="Beschreibung"
          formControlName="description"></textarea>
        <app-error-message
          [formField]="form.get('description')"></app-error-message>
      </div>

      <div class="input-picture flex-c gap-24 align-self-stretch">
        <span class="font-medium-headline-medium">
          Bild des Mitgliederbereichs
        </span>
        <div class="add-picture">
          <button
            type="button"
            class="upload-area cursor-pointer border-none"
            [style.background-image]="
              selectedImage ? 'url(' + selectedImage + ')' : ''
            "
            [style.background-size]="'cover'"
            [style.background-position]="'center'"
            (click)="handleImageUpload()">
            <div class="circle-xsmall border-none">
              <div class="circle-icon">
                <i class="fa-regular fa-plus"></i>
              </div>
            </div>
          </button>
          <div class="title font-medium-headline-small">
            Bild hinzufügen oder ändern
          </div>
          <div class="subtitle font-regular-body-medium">
            Empfohlenes Format: 1:1, mind. 400x400px. Das Bild wird als
            Hintergrund im Mitgliederbereich verwendet.
          </div>
        </div>
        <input
          type="file"
          #fileInput
          accept="image/*"
          (change)="onFileSelected($event)"
          style="display: none" />
      </div>
    </form>
  } @else {
    <div class="loading-wrapper">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="100">
      </mat-progress-spinner>
    </div>
  }
</div>
